import * as React                          from 'react'
import { connect }                         from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'

import Grid from '@material-ui/core/Grid'

import { AccountType, Program }                           from '../../api'
import { api }                                            from '../../client'
import {
  communicationToUiState,
  communicationWasSuccessful,
}                                                         from '../../project-utils'
import { isAdmin }                                        from '../../project-utils/permissions'
import {
  ApplicationState,
  companiesGetRequest,
  genProgramCreateRequest,
  programsGetRequest,
  programsFinishedGetRequest,
  selectAccountType,
  selectAllPrograms,
  selectAllProgramsFinished,
  selectCompanies,
}                                                         from '../../redux'
import { PermissionGuard, SearchField }                   from '../atoms'
import CreateProgramForm                                  from '../forms/ProgramCreateForm'
import { ProgramFormValues }                              from '../forms/schemas'
import withDialogControls, { InjectedDialogControlProps } from '../hocs/withDialogControls'
import withValue, { InjectedValueProps }                  from '../hocs/withValue'
import { ProgramList, ProgramsBar }                       from '../molecules'

const mstp = (state: ApplicationState) => {
  const accountType = selectAccountType(state) as AccountType

  return {
    accountType,
    companies: selectCompanies(state),
    programs:  selectAllPrograms(state),
    programsFinised:  selectAllProgramsFinished(state),

    companiesGetCommunication:  companiesGetRequest.communicationSelector(state),
    programsGetCommunication:   programsGetRequest.communicationSelector(state),
    programsFinishedGetCommunication:   programsFinishedGetRequest.communicationSelector(state),
    programCreateCommunication: genProgramCreateRequest(accountType).communicationSelector(state),
  }
}

const mdtp = (dispatch) => {
  return {
    getCompanies:         (...args) => dispatch(companiesGetRequest.actionCreator(...args as any)),
    getPrograms:          (...args) => dispatch(programsGetRequest.actionCreator(...args as any)),
    getProgramsFinished:  (...args) => dispatch(programsFinishedGetRequest.actionCreator(...args as any)),
    genCreateProgram:     (accountType: AccountType) =>
                            (...args) =>
                              dispatch(
                                (genProgramCreateRequest(accountType) as any)
                                  .actionCreator(...args)
                              ),
  }
}

type ProgramsProps =
  RouteComponentProps<{}>
  & InjectedDialogControlProps
  & InjectedValueProps

const mergeProps = (
  { accountType, ...stateRest }: ReturnType<typeof mstp>,
  { genCreateProgram, ...actionsRest }: ReturnType<typeof mdtp>,
) => {
  return {
    ...stateRest,
    ...actionsRest,
    accountType,
    createProgram: genCreateProgram(accountType),
  }
}

type Props =
  ProgramsProps
  & ReturnType<typeof mergeProps>

class Programs extends React.Component<Props> {
  private readonly exportRequest = api.exportPrograms()
  state = {
    viewHistory:false
  }
  public componentDidMount () {
    if (isAdmin(this.props.accountType)) {
      this.props.getCompanies()
    }

    this.props.getPrograms()
  }

  public componentDidUpdate (lastProps: Props) {
    if (
      communicationWasSuccessful(
        lastProps.programCreateCommunication,
        this.props.programCreateCommunication,
      )
    ) {
      this.props.close()
    }
  }

  public render () {
    return (
      <Grid container direction={'column'} spacing={16}>
        <PermissionGuard check={isAdmin}>
          <Grid item>
            {this.renderCreateProgramForm()}
            {this.renderControls()}
          </Grid>
        </PermissionGuard>

        <Grid item>
          <SearchField
            onChange={this.props.handleChange}
            value={this.props.value}
          />
        </Grid>

        <Grid item>
          {this.renderList()}
        </Grid>
      </Grid>
    )
  }

  private renderList = () =>{
    if(!this.state.viewHistory){
      return this.renderProgramList()
    }
    else{
      return this.renderProgramFinishedList()
    }
  }

  private renderProgramFinishedList = () =>{
    const { programs, programsFinishedGetCommunication } = this.props

    let prg = programs.filter(f => f.details.deleted != null);

    return (
      <ProgramList
        isCached={!!prg.length}
        onProgramClick={this.selectProgram}
        ui={communicationToUiState(programsFinishedGetCommunication)}
        programs={prg}
        filterValue={this.props.value}
      />
    )
  }

  private renderProgramList = () => {
    const { programs, programsGetCommunication } = this.props

      let prg = programs.filter(f => f.details.deleted == null);

      return (
        <ProgramList
          isCached={!!prg.length}
          onProgramClick={this.selectProgram}
          ui={communicationToUiState(programsGetCommunication)}
          programs={prg}
          filterValue={this.props.value}
        />
      )
  }
  
  public getProgramasFinished = () =>{
   
    if(this.state.viewHistory){
      this.setState({ viewHistory: false });
    }
    else{
      this.setState({ viewHistory: true });
      let prg = this.props.getProgramsFinished()
      console.log(prg)
    }
  }

  private renderControls = () => {
    const {
      open,
      companiesGetCommunication: { fetching },
    } = this.props

    let buton_history = 'active'

    if(!this.state.viewHistory){
      buton_history = 'history'
    }else
    {
      buton_history = 'active'
    }


    return (
      <ProgramsBar
        onAddClick={open}
        companiesFetching={fetching}
        exportRequest={this.exportRequest}
        onHistoryClick={this.getProgramasFinished}
        history_active= {buton_history}
      />
    )
  }

  private renderCreateProgramForm = () => {
    const {
      close,
      isOpen,
      programCreateCommunication,
      companies,
    } = this.props

    return (
      <CreateProgramForm
        onSubmit={this.handleCreationSubmit}
        close={close}
        isOpen={isOpen}
        companies={companies}
        {...programCreateCommunication}
      />
    )
  }

  private selectProgram = (program: Program) => {
    const { history, match } = this.props

    history.push(`${match.url}/${program.id}`)
  }

  private handleCreationSubmit = (values: ProgramFormValues) => {
    this.props.createProgram(values)
  }
}

export default connect(mstp, mdtp, mergeProps)(
  withDialogControls(
    withRouter(
      withValue(
        Programs
      )
    )
  )
)



// WEBPACK FOOTER //
// ./src/components/environments/Programs.tsx